import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDb4BjOKF--_yFXl2945g3fbuu0TwMLDdY",
  authDomain: "bulletheque.firebaseapp.com",
  projectId: "bulletheque",
  storageBucket: "bulletheque.firebasestorage.app",
  messagingSenderId: "308872703033",
  appId: "1:308872703033:web:e3859a8214fea93068f1e8"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
// Storage supprimé — photos stockées en Firestore base64

// Cache offline PWA
enableIndexedDbPersistence(db).catch(err => {
  if (err.code !== 'failed-precondition' && err.code !== 'unimplemented') {
    console.warn('Firestore offline cache:', err.code);
  }
});

export default app;
